import { cn } from "@nexus/ui";

/**
 * Shared chrome for header nav links and dropdown / combobox triggers.
 *
 * One family for the whole bar: same height, padding, radius, and type.
 * Selected (current location) is the only use of the primary tint.
 * Open matches hover — expanding a menu is not the same as being on that page.
 */
export const HEADER_TRIGGER_BASE =
  "inline-flex min-h-8 cursor-pointer items-center gap-1.5 rounded-[10px] px-3 py-1.5 text-[13px] font-medium tracking-[-0.01em] transition-colors duration-150 select-none outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]";

export const HEADER_TRIGGER_REST =
  "text-[var(--muted-foreground)] hover:bg-[var(--muted)] hover:text-[var(--foreground)]";

export const HEADER_TRIGGER_OPEN =
  "bg-[var(--muted)] text-[var(--foreground)]";

export const HEADER_TRIGGER_SELECTED =
  "bg-[var(--primary)]/10 text-[var(--primary-subtle-foreground)]";

export const HEADER_TRIGGER_STATIC =
  "inline-flex min-h-8 items-center gap-1.5 rounded-[10px] px-3 py-1.5 text-[13px] font-medium tracking-[-0.01em] text-[var(--muted-foreground)]";

export function headerTriggerClassName({
  open = false,
  selected = false,
  className,
}: {
  open?: boolean;
  selected?: boolean;
  className?: string;
} = {}): string {
  return cn(
    HEADER_TRIGGER_BASE,
    selected ? HEADER_TRIGGER_SELECTED : open ? HEADER_TRIGGER_OPEN : HEADER_TRIGGER_REST,
    className,
  );
}
